import axios from "axios"
export default axios.create({
    baseURL : "https://api.encrypt-o.ir/v1" ,
    headers: {
        "Content-type": "application/json"
      }
})